import React from 'react';
import PropTypes from 'prop-types';
import { SIZE_BIG, SIZE_MEDIUM, SIZE_SMALL } from '../constants';
import ControlUnit from '../assets/components/ControlUnit';
import AlarmColdTemperature from '../assets/components/AlarmColdTemperature';
import AlarmGeneral from '../assets/components/AlarmGeneral';
import AlarmHotTemperature from '../assets/components/AlarmHotTemperature';
import AlarmWarning from '../assets/components/AlarmWarning';
import NetworkError from '../assets/components/NetworkError';
import OpenCircuit from '../assets/components/OpenCircuit';
import ShortCircuit from '../assets/components/ShortCircuit';
import CloudConnect from '../assets/components/CloudConnectColored';
import CloudDisconnect from '../assets/components/CloudDisconnectColored';
import { colorsModeUI } from '../modeUI';

import './index.css';

export const ICON_CONTROL_UNIT = 'ICON_CONTROL_UNIT';
export const ICON_ALARM_COLD_TEMPERATURE = 'ICON_ALARM_COLD_TEMPERATURE';
export const ICON_ALARM_GENERAL = 'ICON_ALARM_GENERAL';
export const ICON_ALARM_HOT_TEMPERATURE = 'ICON_ALARM_HOT_TEMPERATURE';
export const ICON_ALARM_WARNING = 'ICON_ALARM_WARNING';
export const ICON_NETWORK_ERROR = 'ICON_NETWORK_ERROR';
export const ICON_OPEN_CIRCUIT = 'ICON_OPEN_CIRCUIT';
export const ICON_SHORT_CIRCUIT = 'ICON_SHORT_CIRCUIT';
export const ICON_CLOUD_CONNECT = 'ICON_CLOUD_CONNECT';
export const ICON_CLOUD_DISCONNECT = 'ICON_CLOUD_DISCONNECT';

const iconMapping = {
  ICON_CONTROL_UNIT: <ControlUnit id="controlUnit" />,
  ICON_ALARM_COLD_TEMPERATURE: (
    <AlarmColdTemperature id="alarmColdTemperature" />
  ),
  ICON_ALARM_GENERAL: <AlarmGeneral id="alarmGeneral" />,
  ICON_ALARM_HOT_TEMPERATURE: <AlarmHotTemperature id="alarmHotTemperature" />,
  ICON_ALARM_WARNING: <AlarmWarning id="alarmWarning" />,
  ICON_NETWORK_ERROR: (
    <NetworkError id="networkError" className="network-error" />
  ),
  ICON_OPEN_CIRCUIT: <OpenCircuit id="openCircuit" />,
  ICON_SHORT_CIRCUIT: <ShortCircuit id="shortCircuit" />,
  ICON_CLOUD_CONNECT: <CloudConnect id="cloudConnect" />,
  ICON_CLOUD_DISCONNECT: <CloudDisconnect id="cloudConnect" />,
};

/**
 * Ui Icon
 * Display a predefined image as an icon
 * Parameters (Props):
 * @param string icon: [ICON_CONTROL_UNIT,
 *                     ICON_ALARM_COLD_TEMPERATURE,
 *                     ICON_ALARM_GENERAL,
 *                     ICON_ALARM_HOT_TEMPERATURE,
 *                     ICON_ALARM_WARNING,
 *                     ICON_NETWORK_ERROR,
 *                     ICON_OPEN_CIRCUIT,
 *                     ICON_SHORT_CIRCUIT]
 * @param bool disable
 * @param func onClick
 * @param string size
 * @param string color
 * @param string mode
 */
export default class UiIcon extends React.PureComponent {
  constructor(props) {
    super(props);
    this.getSizeIcon = this.getSizeIcon.bind(this);
  }

  /**
   * Get size icon
   * This function get the size of the icon. if not size was selected, then the
   * default size SIZE_MEDIUM will be chosen
   * @return string size
   */
  getSizeIcon() {
    let { size } = this.props;
    if (size !== SIZE_BIG && size !== SIZE_SMALL && size !== SIZE_MEDIUM) {
      size = SIZE_MEDIUM;
    }
    return size;
  }

  render() {
    const { icon, disable, color, onClick, mode } = this.props;

    const size = this.getSizeIcon();
    let imageSVG = iconMapping[icon];
    imageSVG = (
      <imageSVG.type
        {...imageSVG.props}
        {...{ className: `ui-icon ${imageSVG.props.className} ${size}` }}
      />
    );
    if (onClick && !disable) {
      imageSVG = <imageSVG.type {...imageSVG.props} {...{ onClick }} />;
    }
    let style = {};
    if (mode !== null) {
      const colors = colorsModeUI(mode);
      style.fill = colors.TEXT_COLOR;
    }
    /* icon */
    if (color) {
      style = { fill: color };
    }
    imageSVG = <imageSVG.type {...imageSVG.props} {...style} />;

    return imageSVG;
  }
}

UiIcon.propTypes = {
  icon: PropTypes.string.isRequired,
  disable: PropTypes.bool,
  onClick: PropTypes.func,
  size: PropTypes.string,
  color: PropTypes.string,
  mode: PropTypes.string,
};

UiIcon.defaultProps = {
  onClick: null,
  size: SIZE_MEDIUM,
  mode: null,
};
